<template>
	<div class="fashion-show">
		<Breadcrumb :crumb="crumb"></Breadcrumb>
		<div class="banner">
			<img src="../assets/images/fashop-show/banner@2x.png" />
		</div>
		<div class="category" style="display: none;">
			<a class="tab" href="javascript:;" :class="{'on': cur === index }" v-for="(item,index) in categoryList"
				:key="index" @click="changeNav(index)">{{item.name}}</a>

		</div>
		<div class="pic-box">
			<div class="pic" v-for="(item,index) in pics" :key="index">
				<img :src="item.img" />
			</div>
			<!-- <Page :current="1" :total="100" show-total></Page> -->

		</div>
	</div>

</template>

<script>
	import Breadcrumb from "@/components/Breadcrumb.vue";

	export default {
		name: "Fashionshow",
		components: {
			Breadcrumb,
		},
		data() {
			return {
				crumb: [{
					title: "服装展示",
					path: "fashionshow",
				}, ],
				cur: 0,
				categoryList: [{
						name: "男士西装",
						id: 1,
					},
					{
						name: "男士大衣",
						id: 2,
					},
					{
						name: "男士衬衣",
						id: 3,
					},
					{
						name: "男士POLO",
						id: 4,
					},
				],
				pics: [{
						img: require('../assets/images/home/products/1.png')
					},
					{
						img: require('../assets/images/home/products/2.png')
					},
					{
						img: require('../assets/images/home/products/3.png')
					},
					{
						img: require('../assets/images/home/products/4.png')
					},
					{
						img: require('../assets/images/home/products/5.png')
					},
					{
						img: require('../assets/images/home/products/6.png')
					},
					{
						img: require('../assets/images/home/products/7.png')
					},
					{
						img: require('../assets/images/home/products/8.png')
					},
					{
						img: require('../assets/images/home/products/9.png')
					},
					{
						img: require('../assets/images/home/products/10.png')
					},
					{
						img: require('../assets/images/home/products/11.png')
					},
					{
						img: require('../assets/images/home/products/12.png')
					},
					{
						img: require('../assets/images/home/products/13.png')
					},
					{
						img: require('../assets/images/home/products/14.png')
					},
					{
						img: require('../assets/images/home/products/15.png')
					},
				],

			};
		},

		methods: {
			changeNav(cur) {
				this.cur = cur;
			},
		},
	};
</script>

<style scoped lang="scss">
	.fashion-show {
		width: 1170px;
		margin: 20px auto;

		.banner {
			margin-top: 20px;
			width: 100%;
			height: 200px;
		}

		.category {
			width: 100%;
			padding-left: 4px;

			display: flex;

			.tab {
				font-size: 15px;
				font-weight: 400;
				line-height: 21px;
				color: #666666;
				position: relative;
				margin-right: 20px;
				height: 50px;

				line-height: 50px;

				&.on {
					color: #0f114a;
					font-weight: bold;
					font-size: 18px;

					&::after {
						content: "";
						width: 100%;
						height: 2px;
						background: #0f114a;
						position: absolute;
						bottom: 0;
						left: 0;
						right: 0;
						z-index: 1;
					}
				}
			}
		}

		.pic-box {
			margin-top: 20px;
			width: 100%;

			.pic {
				width: 270px;
				height: 270px;
				margin-bottom: 30px;
				display: inline-block;
				margin-right: 30px;
			}

			.pic:nth-child(4n) {
				margin-right: 0px;
			}
		}
	}
</style>
